import { FeedbackButton } from '../Feedback';

export function OpenAPIShareFeedbackButton() {
    return (
        <FeedbackButton
            kind="secondary"
            flagKey="OPENAPI"
            feedbackTitle="Tell us what you think and help us improve the OpenAPI support."
            size="medium"
        />
    );
}
